// global modules
import { mapActions, mapState } from 'vuex'
import {
    ModelDataTable,
    VBtnAction,
} from '@/components/reusable_components/next'

// local modules
import PurchaseQuotationService from '@/services/api/Purchase/PchPurchaseQuotation'

// local objects
import filters from './filters'
import headers from './headers'

/**
 * @description
 *
 */
export default {
    name: 'purchase-invoice-list',
    components: {
        ModelDataTable,
        VBtnAction,
    },
    computed: {
        //
        ...mapState('SnackbarModalModule', {
            responseConfirm: 'responseConfirm',
        }),

        /**
         * @description
         *
         */
        tableProps() {
            return {
                service: new PurchaseQuotationService().toList(),
                filters,
                headers,
                rowsPerPage: 25,
            }
        },
    },
    data() {
        return {
            selected: null,
        }
    },
    methods: {
        /**
         * @description
         *
         */
        ...mapActions('MenuesModule', {
            setItemsTopBar: 'setItemsTopBar',
            setTitleTopBar: 'setTitleTopBar',
        }),

        /**
         * @description
         */
        ...mapActions('SnackbarModalModule', {
            setErrorSnackbar: 'setErrorSnackbar',
            setSuccessSnackbar: 'setSuccessSnackbar',
            setWarningSnackbar: 'setWarningSnackbar',
        }),

        /**
         * @description
         *
         */
        create() {
            this.$router.push({ name: 'purchase-quotation-create' })
        },

        /**
         * @description
         *
         */
        detail(event) {
            this.$router.push({
                name: 'purchase-quotation-update',
                params: { id: event.item.id },
            })
        },

        /**
         * @description
         *
         */
        error() {
            this.setErrorSnackbar(
                'Error al intentar eliminar la cotización de compra.'
            )
        },

        /**
         * @description
         *
         */
        remove(event) {
            //
            this.setWarningSnackbar({
                confirm: 'confirmar',
                message: `¿Confirma la eliminación de la cotización de compra #${
                    event.item.id
                }?`,
                title: 'Eliminar',
            })

            //
            this.selected = event.item
        },

        /**
         *
         */
        showPdf(res) {
            var fileURL = URL.createObjectURL(res.data)
            window.open(fileURL)
        },

        /**
         *
         */
        submitPdf(event) {
            event.item.pdf().then(this.showPdf)
        },

        /**
         * @description
         *
         */
        success() {
            this.setSuccessSnackbar(
                'Cotización de compra eliminada exitosamente.'
            )
        },
    },
    watch: {
        /**
         *
         */
        responseConfirm(val) {
            switch (val) {
                case 'confirmar':
                    return this.selected
                        .delete()
                        .then(this.success)
                        .then(this.$refs.table.refresh)
                        .catch(this.error)
            }
        },
    },
    beforeMount() {
        // set the view title
        this.setTitleTopBar('Cotizaciones de compra')

        // set the view top bar items
        this.setItemsTopBar([
            {
                action: this.create,
                color: 'accent',
                icon: 'add_circle',
                text: 'crear cotización de compra',
                tip: 'Crear nueva cotización de compra',
                can: 'CREATE_PURCHASE_QUOTATION',
            },
        ])
    },
    beforeRouteEnter(to, from, next) {
        next(ctx => {
            if (!ctx.$can('VIEW_ALL_PURCHASE_QUOTATION')) ctx.$router.push('/')
        })
    },
}
